import { CustomPopover } from '@aibees/shared/components';
import { TabList, TabPanel } from '@mui/lab';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomPopover)``;

export const Tabs = styled(TabList)``;

export const Panel = styled(TabPanel)`
  padding: 0;
`;
